import React, { Component } from 'react';
import styles from './styles.scss';

// type：{btn, right_score_btn, img_btn}

class WBtn extends Component 
{
  render() 

  { 
    const onClick = this.props.onClick;
    const btn_type = this.props.type;
    

    let map = {
      'default': styles["btn"],
      'cancel' : [styles["btn"], styles["cancel"]].join(' '),
      'sm' : [styles["btn"], styles["sm"]].join(' '),
    }
    let btn_class = map[btn_type] ? map[btn_type] : map['default'];
    let title = this.props.title
    return (
      <div onClick={() => onClick(title) } className={btn_class}>
        { this.props.title }
      </div>
    );
  }
}

WBtn.defaultProps = {
  title: 'Click',
  type: '',
  img: '',
  size: '',
  onClick: function(title){  }
};

export default WBtn;



// WEBPACK FOOTER //
// ./src/components/WBtn/WBtn.js